import req from 'shared/req';

export const updateParent = (data = {}, fields = '_id') => {
  const id = data.id || 'me';
  delete data.id;

  const url = `/v1/parents/${id}?fields=${fields}`;

  return req({
    url,
    method: 'patch',
    data,
  });
};

export const getParent = (id = 'me', fields = '_id') => {
  const url = `/v1/parents/${id}`;

  return req({
    url,
    method: 'get',
    data: {fields},
  });
};
